import React, { useState } from 'react'
import { PropTypes } from 'prop-types'
import cn from 'classnames'

const Abbreviation = ({ title, children, ...props }) => {
  const [ expanded, setExpanded] = useState(false)
  const className = cn({
    'abbr-button': true,
  })
  return (
    <span>
      <abbr
        title={title}
        {...props}
        role="button"
        className={className}
        aria-expanded={expanded}
        onClick={() => setExpanded(!expanded)}
      >
        <span className="abbr-inner">
          {children}
        </span>
        <span className="abbr__arrow" />
      </abbr>
      {expanded && (
        <div className="abbr-title">{title}</div>
      )}
    </span>
  )
}

Abbreviation.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
}

export default Abbreviation
